import { useRef } from 'react';
import PropTypes from 'prop-types';
// libraries
import { Grid, Dialog, Container, Stack, Button, Box } from '@mui/material';
// components
import ArchivedOrRestored from '../ArchivedOrRestored';
import Iconify from '../Iconify';
import { Transition } from '.';
// redux
import { useSelector } from '../../redux/store';
// styles
import {
    reminderDialogStyle,
    reminderStackStyle,
    reminderFooterStyle,
    cancelButtonStyle,
    saveButtonStyle
} from '../../styles/AddReminderPopup';

const ArchivedOrRestorePopup = ({ open, onClose, handleClose, practiceByLeadId }) => {
    const inputRef = useRef();
    const { multiLead } = useSelector((state) => state.lead);

    const handleNext = async () => {
        await inputRef.current.submit();
    };

    return (
        <Dialog
            TransitionComponent={Transition}
            open={open}
            onClose={onClose}
            sx={reminderDialogStyle}
        >
            <Stack sx={reminderStackStyle}>
                <Grid container spacing={1} sx={{ margin: 'auto', width: '100%' }}>
                    <Container
                        maxWidth={'xl'}
                        sx={{ padding: '0 !important' }}
                    >
                        <ArchivedOrRestored onClose={onClose} ref={inputRef} handleClose={handleClose} practiceByLeadId={practiceByLeadId} />
                    </Container>
                </Grid>
            </Stack>
            <Box sx={reminderFooterStyle}>
                <Button
                    color='inherit'
                    sx={cancelButtonStyle}
                    onClick={() => onClose(true)}
                >
                    Cancel
                </Button>
                <Button
                    color='error'
                    variant='contained'
                    onClick={handleNext}
                    sx={saveButtonStyle}
                >
                    <Iconify icon={'eva:archive-fill'} sx={{ marginRight: '10px' }} />
                    {multiLead.type === 'Archive' ? 'Archive' : 'Restore'}
                </Button>
            </Box>
        </Dialog>
    );
};

export default ArchivedOrRestorePopup;

ArchivedOrRestorePopup.propTypes = {
    open: PropTypes.bool,
    onClose: PropTypes.func,
    handleClose: PropTypes.func,
    practiceByLeadId: PropTypes.objectOf(PropTypes.oneOfType([PropTypes.number, PropTypes.string])),
};